import React from 'react'

import Entry from './Entry'
import defaultEntryComponent from './Entry/defaultEntryComponent'
import {getMentionOptionId} from './helpers'

import Popover from "../../../core/gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../core/gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../core/gd-components/gd-popover/@const"
import VScroll from "../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"

type Props = {
    scrollRef           : React.RefObject<any>
    suggestions         : any[]
    focusedOptionIndex  : number
    uniqKey             : string
    theme?              : any
    searchValue         : string
    entryComponent?     : any

    getTargetFunc       : callback
    onMentionSelect     : callback
    onMentionFocus      : callback
    onClickOutside      : callback
}

export default function MentionSuggestionsPopover(props:Props) {
    if (_.filter(props.suggestions, s=>s.type !== 'switch_options').length === 0) {
        return null
    }

    const theme = props.theme || {}

    return (
        <Popover className="mentions-options-container"
                 popoverClass="mentions-options-popover"
                 position={new PopoverPosition({
                       attachment      : "bottom left",
                       targetAttachment: "top left",
                       attachmentType  : PopoverAttachmentType.HORIZONTAL,
                   })}
                   getTargetFunc={props.getTargetFunc}
                   onClickOutside={props.onClickOutside}>
            <VScroll ref={props.scrollRef} className="mentions-options-scroll">
                {props.suggestions.map((mention, index) => {
                    return (
                        <Entry key={mention.id != null ? mention.id : mention.name}
                               onMentionSelect={props.onMentionSelect}
                               onMentionFocus={props.onMentionFocus}
                               isFocused={props.focusedOptionIndex === index}
                               mention={mention}
                               index={index}
                               id={getMentionOptionId(props.uniqKey, index)}
                               theme={theme}
                               searchValue={props.searchValue}
                               entryComponent={props.entryComponent || defaultEntryComponent} />
                    )
                })}
            </VScroll>
        </Popover>
    )
}
